import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../../../hooks'

import { getCalendarGridWeekBlockProps } from './CalendarGridWeekGroup.utils'
import { CalendarGridWeekGroupBlock } from './CalendarGridWeekGroupBlock'
import { CalendarGridWeekGroupDraggableBlock } from './CalendarGridWeekGroupDraggableBlock'
import { CalendarGridWeekGroupMore } from './CalendarGridWeekGroupMore'

function CalendarGridWeekGroup({
  canMoveItemsInTime,
  day,
  group = EMPTY_OBJECT,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { items = EMPTY_LIST, laneCount, moreCount } = group

  const [item] = items

  const blockProps = getCalendarGridWeekBlockProps({ group, locale, timezone })

  return moreCount ? (
    <CalendarGridWeekGroupMore
      blockProps={blockProps}
      day={day}
      items={items}
      moreCount={moreCount}
      onClickItem={onClickItem}
      onClickSecondaryLabel={onClickSecondaryLabel}
    />
  ) : item.tooltip ? (
    <CalendarGridWeekGroupBlock
      blockProps={blockProps}
      item={item}
      onClickItem={onClickItem}
      onClickSecondaryLabel={onClickSecondaryLabel}
    />
  ) : (
    <CalendarGridWeekGroupDraggableBlock
      blockProps={blockProps}
      canMoveItemsInTime={canMoveItemsInTime}
      item={item}
      laneCount={laneCount}
      onClickItem={onClickItem}
      onClickSecondaryLabel={onClickSecondaryLabel}
    />
  )
}

export default CalendarGridWeekGroup
